export function configureFakeBackend() {
    let realFetch = window.fetch;

    window.fetch = function (url, opts) {
        return new Promise((resolve, reject) => {
            // wrap in timeout to simulate server api call
            setTimeout(() => {

                // authenticate
                if (url.endsWith('/users/authenticate') && opts.method === 'POST') {
                    // get parameters from post request
                    let params = JSON.parse(opts.body);

                    // find if any user matches login credentials
                    let isValidUser = params.username === 'pbl' && params.password === 'Ib1_P66';

                    if (isValidUser) {
                        // if login details are valid return user details and fake jwt token
                        let responseJson = {
                            id: 1,
                            username: 'admin',
                            firstName: 'admin',
                            lastName: 'admin',
                            token: 'fake-jwt-token'
                        };
                        resolve({ ok: true, json: () => Promise.resolve(responseJson) });
                    } else {
                        // else return error
                        reject('error_auth');
                    }

                    return;
                }

                // pass through any requests not handled above
                realFetch(url, opts).then(response => resolve(response));

            }, 500);
        });
    }
};



// WEBPACK FOOTER //
// ./src/scripts/ConfigureFakeBackend.js